import React from 'react'
import { styled } from 'styled-components'
import { Link } from 'react-router-dom'
import useScreenSize from '../../hooks/useScreenSize'
import Navbar from '../Navbar'
import useChangeSlider from '../../hooks/useChangeSlides'

const HeroBox = ({ imagesrc }) => {
    const screenSize = useScreenSize();
    const [currentSlide, setSlideIndex] = useChangeSlider(4000);

    return (
        <Container className='hero'>
        <SliderContainer $height={screenSize.height}>
            <SlideTrack>
                {imagesrc.map((imagesrc, index) => (
                    <Slide
                        key={index}
                        $isActive={index + 1 === currentSlide}
                        style={{ backgroundImage: `url(${imagesrc})` }}
                    />
                ))}
            </SlideTrack>

                <div className="hero-content-box">
                    <Navbar />
                    <div className="hero-content">
                        <div className="hero-top-content">
                            <p>AFRICAN MATERIALS RESEARCH SOCIETY</p>
                        </div>
                        <h4>Establishing Networks, Promoting Materials Research.</h4>
                        <Link to='/signup'>
                            <button className='signup-btn'>JOIN AMRS</button>
                        </Link>
                    </div>
                </div>

            
            <RadioButtons>
                <input type="radio" name="radio-btn" id="radio1" onChange={() => setSlideIndex(1)} defaultChecked />
                <input type="radio" name="radio-btn" id="radio2" />
                <input type="radio" name="radio-btn" id="radio3" />
                <input type="radio" name="radio-btn" id="radio4" />
                
                <div className="navigation-dots">
                    {[1, 2, 3, 4].map((num) => (
                        <label 
                            key={num} 
                            htmlFor={`radio${num}`}
                            className={`dot ${currentSlide === num ? 'active' : ''}`}
                            onClick={() => setSlideIndex(num)}
                        />
                    ))}
                </div>
            </RadioButtons>
        </SliderContainer>
        </Container>
    );
};
  
const SliderContainer = styled.div`
    width: 100%;
    height: ${props => props.$height}px;
    overflow: hidden;
    position: relative;
`;

const SlideTrack = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

const Container = styled.main`
    position: relative;
    width: 100%;
    height: 100%;
    animation: heroLoad 2s ease-in-out;
    z-index: 2;

    .hero-content-box{
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        background-color: rgba(0,0,0,0.1);
        color: var(--color-white);

        .hero-content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 2em;

            .hero-top-content{
                display: flex;
                align-items: center;
                p{
                    font-size: 0.7rem;
                    font-weight: 400;
                }
            }

            h4{
                font-size: 2em;
                margin: 0.5em 0;
                width: 80%;
                font-family: "PT Serif", serif;
                font-style: normal;
                font-weight: 600;
                letter-spacing: .005em;
                line-height: 1.18;
            }

            .signup-btn{
                background-color: var(--color-white);
                color: var(--color-black);
                border: none;
                padding: 1.5em 3em;
                border-radius: 0.3em;
                font-size: 1em;
                font-weight: 400;
                letter-spacing: 0.1em;
                margin: 0.5em 0;
                transition: all 0.3s ease-in-out;
                &:hover{
                    cursor: pointer;
                    background-color: var(--color-black-light);
                    color: var(--color-white-light);
                }
            }
        }
    }

    @keyframes heroLoad{
        from{
            clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
        }
        to{
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
    }

    @media only screen and (min-width: 800px){
        .hero-content-box{
            .hero-content{
                padding: 0 3em;
                .hero-top_content{
                    p{
                        font-size: 1em;
                    }
                }
                h4{
                    font-size: 2.5em;
                    width: 40%;
                }
                .signup-btn{
                    font-size: 1.1em;
                }
            }
        }
    } 
`;

const Slide = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: ${props => (props.$isActive ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;
    background-size: cover;
    background-position: center;
`;

const RadioButtons = styled.div`
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    
    input[type="radio"] {
        display: none;
    }
    
    .navigation-dots {
        display: flex;
        gap: 10px;
    }
    
    .dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid white;
        background: transparent;
        cursor: pointer;
        transition: background-color 0.3s ease;
        
        &.active {
            background: white;
        }
        
        &:hover {
            background: rgba(255, 255, 255, 0.5);
        }
    }
`;

export default HeroBox;